<template>
  <span class="rating-bar">
    <template v-for="i in 5">
      <i style="color: orange" :key="i" :class="i <= starVal ? 'fas fa-star' : 'far fa-star'"></i>
    </template>
    <span class="badge badge-soft-warning" v-if="star">
      <strong> {{ star }}</strong>
    </span>
  </span>
</template>

<script>
export default {
  name: "Star",
  computed: {
    starVal() {
      return Math.round(this.star)
    }
  },
  props: {
    star: {
      Default: 1,
      type: Number
    }
  }
}
</script>

<style scoped>
.rating-bar {
  min-width: 10em !important;
}
</style>